import React from "react";
import { getVerificationTickets } from "../api";
import VerifiedReportsModal from "./VerifiedReportsModal";

function CropIcon({ name, className = "" }) {
  switch (name.toLowerCase()) {
    case "wheat":
      return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
          <path d="M12 2v20M8 5l4 3 4-3M8 10l4 3 4-3M8 15l4 3 4-3" />
        </svg>
      );
    case "corn":
      return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
          <rect x="9" y="3" width="6" height="14" rx="3" />
          <path d="M6 15c2-1 3-4 3-8M18 15c-2-1-3-4-3-8M12 20v2" />
          <path strokeDasharray="2,2" d="M12 3v14M9 7h6M9 11h6M9 14h6" />
        </svg>
      );
    case "Paddy":
    case "paddy":
      return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
          <path d="M4 22c0-8 6-14 14-14M18 8c-1.5-.5-3.5 0-4 1.5M15 11c-1.5-.5-3.5 0-4 1.5M12 14c-1.5-.5-3.5 0-4 1.5" />
          <path d="M18 8c1-.5 2-2 1.5-3M15 11c1-.5 2-2 1.5-3M12 14c1-.5 2-2 1.5-3" />
        </svg>
      );
    // case "grapes":
    // case "grape":
    //   return (
    //     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    //       <circle cx="12" cy="8" r="2" />
    //       <circle cx="9" cy="11" r="2" />
    //       <circle cx="15" cy="11" r="2" />
    //       <circle cx="12" cy="14" r="2" />
    //       <circle cx="9" cy="17" r="2" />
    //       <circle cx="15" cy="17" r="2" />
    //       <circle cx="12" cy="20" r="2" />
    //       <path d="M12 6V3m0 0h2" />
    //     </svg>
    //   );
    // case "apple":
    //   return (
    //     <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
    //       <path d="M12 17c-2 2-6 2-7-1a5 5 0 0 1 1-7c2-1 4 0 5 1 1-1 3-2 5-1a5 5 0 0 1 1 7c-1 3-5 3-7 1z" />
    //       <path d="M12 8c0-2 1-3 2-4" />
    //       <path d="M14 4c2 0 3 1 3 3s-1 3-3 3" />
    //     </svg>
    //   );
    case "soybeans":
    case "soybean":
      return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
          <path d="M3 12c3-4 8-4 13-1 3 2 5 1 5 1s-2 3-5 2c-5-2-10-2-13 0z" />
          <circle cx="7" cy="11" r="1.5" />
          <circle cx="11" cy="12" r="1.5" />
          <circle cx="15" cy="12" r="1.5" />
        </svg>
      );
    case "chickpea":
      return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
          <circle cx="9" cy="10" r="2" />
          <circle cx="15" cy="11" r="2" />
          <circle cx="12" cy="15" r="2" />
          <circle cx="10" cy="18" r="1.5" />
          <circle cx="14" cy="18" r="1.5" />
          <path d="M9 10c0-1 .5-1.5 1-1M15 11c0-1 .5-1.5 1-1" />
        </svg>
      );
    case "cotton":
      return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
          <circle cx="12" cy="12" r="3" />
          <circle cx="9" cy="10" r="2.5" />
          <circle cx="15" cy="10" r="2.5" />
          <circle cx="12" cy="8" r="2.5" />
          <circle cx="12" cy="16" r="2.5" />
          <circle cx="9" cy="14" r="2.5" />
          <circle cx="15" cy="14" r="2.5" />
          <path d="M12 18v3" />
        </svg>
      );
    default:
      return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
          <path d="M12 2v20M17 5H7M19 12H5" />
        </svg>
      );
  }
}

export default function Dashboard({ onSelectModule, onToggleSidebar, isSidebarOpen, onLogout }) {
  const [showProfileMenu, setShowProfileMenu] = React.useState(false);
  const profileMenuRef = React.useRef(null);

  const [userTickets, setUserTickets] = React.useState([]);
  const [showVerifiedModal, setShowVerifiedModal] = React.useState(false);

  const loadUserTickets = React.useCallback(async () => {
    const sessionId = localStorage.getItem("cropscan_session_id");
    if (!sessionId) return;
    try {
      const res = await getVerificationTickets(sessionId);
      if (res.status === "success") setUserTickets(res.tickets || []);
    } catch (err) {
      console.warn("Failed to load user tickets", err);
    }
  }, []);

  React.useEffect(() => {
    loadUserTickets();
  }, [loadUserTickets]);

  React.useEffect(() => {
    if (!showProfileMenu) return;
    const handleClickOutside = (e) => {
      if (profileMenuRef.current && !profileMenuRef.current.contains(e.target)) {
        setShowProfileMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showProfileMenu]);
  const crops = [
    {
      name: "Wheat",
      image: "https://lh3.googleusercontent.com/aida-public/AB6AXuBgEPELAiiTovidireQ_7PnQ9BpTX0g4sbjzWAxEpP_chepwjIm3Ly7D9_1Dwos-r1kNBXhk4TDi0vtPONl9NKOeTuI3EUXH-Hix--Nx9_49prR6dnnLhLICqaiVhziIViy-LrCeJ-RleIQQQ3Kunx80wjH0dQsgQA4NKH4jJ34RWbWBKRZB96X_HnGwGFtczeEJ0fTY2B76k-8jyfz2wRFAOlzK8llSmoc98YiLosPRtd8xif_3PHO"
    },
    {
      name: "Corn",
      image: "https://lh3.googleusercontent.com/aida-public/AB6AXuD4cnGTUYZOMMOWXNu1dNQJu58MxMn7y1rQLA7ZNxtyF_hDkptPFHZzVoe48vvOsphW5908t-oJW-4Y-Y6CDvZyifq7jfVizTy3_33mN8k8uXkEzxR1iTisBDX-YeZ1bdoXRFk5KF9boUCtxMIiypUCISAgU9Dfu9J1Kc6KSvDAfHgYq-U_rT9mBJTARKwaFx2PUG_KEuAFzXf7RGa0MspQqYJS8BpQbPIHkiu9DJawdnfODNlcornU"
    },
    {
      name: "Paddy",
      image: "https://lh3.googleusercontent.com/aida-public/AB6AXuB5YulULp1Y0xcfHo0Bxs63AeLanmPw1TXP7LYIFrK2YBWzcjfhEtwKzbFMeu-mHXMyzzQTwjgYmV1dxkoyxHpZS9aBz5PdkFkCvt-YrOKB2i0Th-B451_aQvyGpTxbE3DPkV6y1xL-GcYYvnD8WyjfAYEXoMS9UrhAegMxNWomvzbE9h79h4l_QPYKpC2ACrgKNIVaIVUZvLNwKBQfVW1h4cy-lKv85Pb2zetkUZ_C-QC7HeMVc3Yx"
    },
    {
      name: "Soybeans",
      image: "https://lh3.googleusercontent.com/aida-public/AB6AXuA-afczAcuyVSNUbCNGc47FeAZOU2oDjTzULXF-EDKJs_wetEIWO9_5L0CBMc3GhnuOLUzK-SeLlvKSur9eUFD3gHm2VOQmB-0zw-doMExEUg-MxclzkmCtVqF2c5LfVxirll7q1zZ-CX6JURcqu9Gf4KQj8PXuolDYaovPVFi0VcfvpZol2cY6TgWNtwbzhwUyqPaN6DNE6lW3kRA9zRWdNwzkVQUoh9OtC93iVORVbZp7jBySRAd-"
    },
    // {
    //   name: "Grapes",
    //   image: "https://lh3.googleusercontent.com/aida-public/AB6AXuDt_XwmePxTs0Jp5DdgfPdph-VmV4-SJG53pFH-bfW9sHjxwkHFPMW2KR59wV6MuC4ItsAqvqK0dAEPD6Ic3TBYnAayW0AAcDrxFgik3QAKEFizoJ_T6BuFuFRfuTO2VRGtQ3hy1g0wz_QC_SNxUbLu3wWQeDH6erT6U9aeAqMY6t6DqlGhNTX-nd4ZANSGQdMY6yqoVmWtWUoopGAEhx98fuURqq9F4VgBZttQSaFEiDmK2NrsR-yI"
    // },
    // {
    //   name: "Apple",
    //   image: process.env.PUBLIC_URL + "/apple_crop.png"
    // },
    {
      name: "Chickpea",
      image: process.env.PUBLIC_URL + "/chickpea_crop.png"
    },
    {
      name: "Cotton",
      image: process.env.PUBLIC_URL + "/cotton_crop.png"
    }
  ];

  const features = [
    {
      id: "report",
      title: "Crop Report",
      description: "Identify crop types, pests, disease and crop stage at one stop.",
      icon: "assessment",
      iconBg: "bg-primary/10 group-hover:bg-primary/20",
      iconColor: "text-primary"
    },
    {
      id: "crop",
      title: "Crop Identification",
      description: "Identify crop types instantly using state-of-the-art computer vision models optimized for agricultural fields.",
      icon: "spa",
      iconBg: "bg-primary/10 group-hover:bg-primary/20",
      iconColor: "text-primary"
    },
    {
      id: "pest",
      title: "Pest & Disease Identification",
      description: "Identify pests and diseases with high-precision and general advisories to protect your crops.",
      icon: "bug_report",
      iconBg: "bg-error/10 group-hover:bg-error/20",
      iconColor: "text-error"
    },
    {
      id: "stage",
      title: "Crop Stage Identification",
      description: "Monitor growth cycles from seed to harvest.",
      icon: "timeline",
      iconBg: "bg-secondary/10 group-hover:bg-secondary/20",
      iconColor: "text-secondary"
    },
    {
      id: "annotation",
      title: "Annotation Studio",
      description: "Generate high-quality datasets with AI-assisted labeling.",
      icon: "draw",
      iconBg: "bg-tertiary/10 group-hover:bg-tertiary/20",
      iconColor: "text-tertiary"
    }
  ];

  return (
    <div className="h-full overflow-y-auto bg-background text-on-surface font-body-lg overflow-x-hidden pb-16">
      {/* TopAppBar */}
      <header className="sticky top-0 w-full z-40 bg-surface/90 dark:bg-inverse-surface/90 backdrop-blur-md border-b border-outline-variant/30 shadow-sm flex justify-between items-center px-4 sm:px-margin-desktop h-16 transition-colors duration-250">
        <div className="flex items-center gap-3 sm:gap-stack-lg">
          <h1 className="font-headline-md text-headline-md font-semibold text-primary">CROPSCAN</h1>
          <nav className="hidden md:flex gap-stack-md">
            <span className="font-label-code text-label-code text-primary font-bold border-b-2 border-primary pb-1 cursor-pointer">Dashboard</span>
          </nav>
        </div>
        <div className="flex items-center gap-stack-md">
          <button className="text-on-surface-variant hover:text-primary transition-colors duration-250 w-10 h-10 flex items-center justify-center rounded-full">
            <span className="material-symbols-outlined">search</span>
          </button>
          <button 
            onClick={() => setShowVerifiedModal(true)}
            className="text-on-surface-variant hover:text-primary transition-colors duration-250 w-10 h-10 flex items-center justify-center rounded-full relative"
            title="Verified Reports"
          >
            <span className="material-symbols-outlined">notifications</span>
            {(() => {
              const seenTickets = JSON.parse(localStorage.getItem("seen_tickets") || "[]");
              const unreadCount = userTickets.filter((t) => t.status === "Resolved" && !seenTickets.includes(t.ticket_id)).length;
              return unreadCount > 0 ? (
                <span className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 bg-error text-white text-[10px] font-extrabold rounded-full ring-2 ring-surface flex items-center justify-center">
                  {unreadCount}
                </span>
              ) : null;
            })()}
          </button>
          <div className="relative" ref={profileMenuRef}>
            <button 
              onClick={() => setShowProfileMenu(!showProfileMenu)}
              className="w-10 h-10 flex items-center justify-center rounded-full border border-outline-variant/30 overflow-hidden bg-white hover:border-primary transition-all duration-250 p-1 shadow-sm hover:scale-105"
            >
              <img
                src={process.env.PUBLIC_URL + "/niruthi_logo.png"}
                alt="Niruthi Logo"
                className="w-full h-full object-contain"
              />
            </button>
            {showProfileMenu && (
              <div className="absolute right-0 mt-2 w-52 bg-white dark:bg-inverse-surface border border-outline-variant/30 rounded-xl shadow-lg z-50 py-2 animate-in fade-in slide-in-from-top-2 duration-150">
                <div className="px-4 py-3 border-b border-outline-variant/20 flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full border border-outline-variant/30 overflow-hidden bg-white shrink-0 p-0.5 shadow-sm">
                    <img
                      src={process.env.PUBLIC_URL + "/niruthi_logo.png"}
                      alt="User Profile"
                      className="w-full h-full object-contain"
                    />
                  </div>
                  <div className="min-w-0">
                    <p className="text-sm font-semibold text-on-surface truncate">Niruthi User</p>
                    <p className="text-xs text-on-surface-variant truncate">Niruthiuser</p>
                  </div>
                </div>
                <button
                  onClick={() => {
                    setShowProfileMenu(false);
                    onLogout();
                  }}
                  className="w-full text-left px-4 py-2.5 text-sm text-red-500 hover:bg-red-500/10 dark:hover:bg-red-500/20 flex items-center gap-2 transition-colors font-medium"
                >
                  <span className="material-symbols-outlined text-[18px]">logout</span>
                  <span>Log Out</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </header>
      <main className="max-w-[1440px] mx-auto px-margin-mobile md:px-margin-desktop py-stack-lg flex flex-col gap-12">
        {/* Partner Logos / Branding Row */}
        {/* <section className="flex flex-col sm:flex-row items-center justify-center gap-8 sm:gap-16 py-4">
          <div className="flex items-center justify-center">
            <img
              src={process.env.PUBLIC_URL + "/niruthi_logo.png"}
              alt="Niruthi Logo"
              className="h-16 sm:h-20 object-contain drop-shadow-md"
            />
          </div>
          <div className="hidden sm:block w-px h-16 bg-outline-variant/40 self-center" />
          <div className="flex items-center justify-center">
            <img
              src={process.env.PUBLIC_URL + "/exp.png"}
              alt="Experiment / Partner"
              className="h-16 sm:h-20 object-contain drop-shadow-md"
            />
          </div>
        </section> */}

        {/* CROPSCAN Banner */}
        {/* <section className="relative overflow-hidden rounded-3xl bg-gradient-to-r from-emerald-800 to-teal-950 p-8 md:p-12 shadow-xl border border-emerald-700/30 text-white flex flex-col items-center justify-center text-center gap-6">
          <div className="flex flex-col items-center text-center gap-3 max-w-2xl mx-auto">
            <h2 className="text-4xl md:text-5xl font-black tracking-tight bg-gradient-to-r from-white via-emerald-100 to-teal-200 bg-clip-text text-transparent">
              CROPSCAN
            </h2>
          </div>
        </section> */}

        {/* Supported Crops Marquee */}
        <section className="flex flex-col gap-stack-md overflow-hidden">
          <h3 className="font-headline-md text-headline-md text-on-surface border-b border-outline-variant/30 pb-2">Supported Crops</h3>

          <div className="marquee-wrapper">
            <div className="marquee-content">
              {/* Copy 1 */}
              {crops.map((crop, idx) => (
                <div key={`crop-1-${idx}`} className="min-w-[200px] rounded-2xl glass-card overflow-hidden crop-card-zoom border border-outline-variant/20 group">
                  <div className="h-32 w-full relative overflow-hidden bg-surface-container">
                    <img
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      alt={crop.name}
                      src={crop.image}
                    />
                  </div>
                  <div className="p-4 flex items-center justify-between">
                    <span className="font-body-lg text-body-lg font-semibold text-on-surface">{crop.name}</span>
                    <CropIcon name={crop.name} className="w-6 h-6 text-primary" />
                  </div>
                </div>
              ))}
              {/* Copy 2 for infinite seamless loop */}
              {crops.map((crop, idx) => (
                <div key={`crop-2-${idx}`} className="min-w-[200px] rounded-2xl glass-card overflow-hidden crop-card-zoom border border-outline-variant/20 group">
                  <div className="h-32 w-full relative overflow-hidden bg-surface-container">
                    <img
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                      alt={crop.name}
                      src={crop.image}
                    />
                  </div>
                  <div className="p-4 flex items-center justify-between">
                    <span className="font-body-lg text-body-lg font-semibold text-on-surface">{crop.name}</span>
                    <CropIcon name={crop.name} className="w-6 h-6 text-primary" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Feature Cards Grid */}
        <section className="grid grid-cols-1 md:grid-cols-2 gap-gutter">
          {features.map((feat) => (
            <button
              key={feat.id}
              onClick={() => onSelectModule(feat.id)}
              className="module-card rounded-2xl p-8 border border-outline-variant/20 flex flex-col text-left group"
            >
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-6 transition-colors ${feat.iconBg}`}>
                <span className={`material-symbols-outlined text-3xl ${feat.iconColor}`}>{feat.icon}</span>
              </div>
              <h4 className="font-headline-md text-headline-md text-on-surface mb-2">{feat.title}</h4>
              <p className="font-body-sm text-body-sm text-on-surface-variant leading-relaxed">{feat.description}</p>
            </button>
          ))}
        </section>
      </main>
      <VerifiedReportsModal
        isOpen={showVerifiedModal}
        onClose={() => setShowVerifiedModal(false)}
        tickets={userTickets}
      />
    </div>
  );
}
